function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#72163b;}.cls-2{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M12.25,23.5A11.25,11.25,0,1,1,23.5,12.25,11.26,11.26,0,0,1,12.25,23.5Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12.25,2A10.25,10.25,0,1,1,2,12.25,10.25,10.25,0,0,1,12.25,2m0-2A12.25,12.25,0,1,0,24.5,12.25,12.27,12.27,0,0,0,12.25,0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12.25,5.7a1.86,1.86,0,1,1-1.78,1.86A1.82,1.82,0,0,1,12.25,5.7Zm2.68,12.74c0,.25-.2.36-.45.36H10c-.25,0-.45-.11-.45-.36v-.23c0-.26.2-.57.45-.57h.45v-5.8H10c-.25,0-.45-.11-.45-.36v-.24c0-.25.2-.56.45-.56h3.57c.25,0,.45.31.45.56v6.4h.44c.25,0,.45.31.45.57Z"
});

var SvgHotspot = function SvgHotspot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Hotspots",
    viewBox: "0 0 24.5 24.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHotspot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hotspot.d4480e68.svg";
export { ForwardRef as ReactComponent };